
import { api } from '@shared/api/api';

export const getTimeTrackingGroupReport =  api.createShow('/time-tracking-groups/:id/entries/export');
